import { render, staticRenderFns } from "./BlankHeader.vue?vue&type=template&id=4d0124d1&"
import script from "./BlankHeader.vue?vue&type=script&lang=ts&"
export * from "./BlankHeader.vue?vue&type=script&lang=ts&"
import style0 from "./BlankHeader.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports